module.exports = __webpack_public_path__ + "img/minus.55f681e8.svg";